import { environmentConfig } from '../../config/environment/environmentConfig'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import DefaultLayout from '../../components/layout/DefaultLayout'
import RegistrationCard from '../../components/app/registration/RegistrationCard'
import type { NextPage } from 'next'

const RegistrationPage: NextPage = () => {
    const { t } = useTranslation('registration')

    return (
        <DefaultLayout title={t('registrationPage.title')}>
            <RegistrationCard/>
        </DefaultLayout>
    )
}

export const getServerSideProps: GetServerSideAndEnvironmentProps<{}> = async ({ locale = 'cs' }) => {
    return {
        props: {
            ...(await serverSideTranslations(locale, ['common', 'registration'])),
            environmentConfig
        }
    }
}

export default RegistrationPage